export let getCommonGeo = (style, mapName: string) => {
    let geo = {
        map: mapName,
        selectedMode: false as boolean | 'single' | 'multiple',
        itemStyle: {
            areaColor: "#AAD5FF",
            borderColor: "white",
            label: { show: false, color: "#fff" },
        },
        emphasis: {
            label: {
                show: false,
            },
            itemStyle: {
                areaColor: "#A5DABB",
                shadowColor: "#888888",
            },
        },
        label: {
            show: false,
            fontSize: style.fontSize - 2,
            color: "#fff",
        },
        roam: true,
        zoom: 1.2,
    }
    return geo;
}
export let getGeo3D = (style, mapName: string = 'mapName') => {
    let geo = {
        map: mapName,
        boxWidth: 80,
        itemStyle: {
            color: '#6BA1DB',
            borderColor: '#E3E3E3',
            opacity: 1,
            borderWidth: 0.8
        },
        label: {
            show: false,
            distance: 0,
            textStyle: {
                color: "#1c1b1b",
                fontSize: 10,
                opacity: 1,
                backgroundColor: "rgba(255,255,255,0.8)",
            },
            formatter: (param) => {
                let temArr = [...param.name];
                temArr.splice(-1, 1);
                return temArr.join("");
            },
        },
        emphasis: {
            itemStyle: {
                color: "#99c2ed",//鼠标放上去
                opacity: 1,
                borderColor: "#e3e3e3",
            },
            label: {
                show: false,
                distance: 0
            },
        },
        light: {
            main: {
                color: "#fff",
                intensity: 1.2,
                shadow: false,
                alpha: 50,
                beta: 10,
            },
            ambient: {
                intensity: 0.3,
            },
        },
    }
    return geo;
}